import React from 'react'
import s from './Desktop.module.scss'
import cx from 'classnames'

import QRCode from 'components/QRCode'

import Bear from 'assets/images/bear-sled.png'
import Hero from 'assets/images/hero-landing.png'
import Ribbon from 'assets/images/ribbon-landing.png'
import Snow from 'assets/images/snow-landing.png'
import Border from 'assets/svg/border-curve-lg.svg'
import Title from 'assets/svg/title-landing.svg'


Desktop.defaultProps = {

};

export default function Desktop(props) {

  return (
    <div className={s.Desktop}>
      <div className={s.background}>
        <img className={s.hero} src={Hero} alt="" />
        <img className={s.ribbon} src={Ribbon} alt="" />
        <img className={cx(s.border, s.left)} src={Border} alt="" />
        <img className={cx(s.border, s.right)} src={Border} alt="" />
        <img className={s.snow} src={Snow} alt="" />
        <img className={s.character} src={Bear} alt="" />
      </div>
      <div className={s.content}>
        <img className={s.title} src={Title} alt="Dashing to the Store" />
      </div>
      <div className={s.QRCodeWrapper}>
        <QRCode className={s.QRCode} />
        <h2>Scan QR Code</h2>
        <p>You will need to switch to your mobile phone to view this experience.</p>
      </div>
    </div>
  );
}
